// extracted by mini-css-extract-plugin
export default {"wrapper":"Checkable_wrapper__q+ipo","add":"Checkable_add__wn5An","label":"Checkable_label__Lu8kW","required":"Checkable_required__PNHbi"};